import {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
} from '@reduxjs/toolkit/query';

import {lanesListSource, userDataSource} from 'app/demo/demo_fixtures';
import {addLaneToList, createLane} from 'app/demo/demo_fixtures/lanes_list';
import {settings_fixture} from 'app/demo/demo_fixtures/settings';

const emptyListResponse = {
  count: 0,
  next: null,
  previous: null,
  results: [],
  num_pages: 1,
};

/* this replaces the original apiQuery and returns mocked data for the demo */
export const apiQuery: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args /*api, extraOptions*/) => {
  const [url, method, body] =
    typeof args === 'string'
      ? [args, 'GET', null]
      : [args.url, args.method || 'GET', args.body];

  switch (url) {
    case '/api/v1/settings/':
      return {data: settings_fixture};
    case '/api/v1/user/': {
      if (method === 'PATCH' && body != null) {
        userDataSource.navigation_links = body.navigation_links;
      }
      // create a copy of the object before sending it to rtk-query, because rtk-query
      // updates it making all properties read-only, making it impossible to change it
      // again on a subsquent patch
      return {data: {...userDataSource}};
    }
    case '/api/v1/lanes/': {
      if (method == 'POST') {
        const lane = createLane(body.name);
        addLaneToList(lane, lanesListSource);
        return {data: lane};
      } else {
        return {
          data: {...lanesListSource},
        };
      }
    }
    case '/api/v1/thread/subscribers/':
      return {data: emptyListResponse};
    case '/api/v1/thread/':
      if (method === 'POST') {
        return {
          data: {
            content_type: body.content_type,
            object_id: body.object_id,
            url: '/api/v1/thread/1/',
          },
        };
      }
      return {data: emptyListResponse};
    default:
      if (url.startsWith('/api/v1/thread/') && method === 'DELETE') {
        return {data: null};
      }
      throw `Tried to gather data for mocked query: ${JSON.stringify(
        args
      )} - but no data-mock fixture is present`;
  }
};
